export default {
  GROUP_GAMES_PAGE_SIZE: 50,
  DEBOUNCE_DURATION: 300,
  INPUT_WARNING_DURATION: 3000,
  GROUP_ICONS_CMS_CONTAINER_NAME_SUFFIX: '7casino_icons',
};
